export const center_app_version = {"commit_sha": "bf002e4e"}
